// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { DateTime } from 'luxon';
import type { PartialDeep } from 'type-fest';

import * as DateHelpers from '../../../utils/dateHelpers';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  NewQuoteConfigSummaryPlant,
  type QuoteConfigSummaryPlant,
  type QuoteConfigSummaryPlantWireFormat,
} from '../QuoteConfigSummaryPlant/QuoteConfigSummaryPlant';

export class QuoteConfigSummary {
  readonly id: string;
  readonly name: string;
  readonly plants: QuoteConfigSummaryPlant[];
  readonly isArchived: boolean;
  readonly plantIsArchived: boolean;
  readonly createdAt: DateTime;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.plants = (data.plants ?? []).map((plants: any) => NewQuoteConfigSummaryPlant(plants));
    this.isArchived = data.isArchived === undefined ? false : data.isArchived;
    this.plantIsArchived = data.plantIsArchived === undefined ? false : data.plantIsArchived;
    this.createdAt = DateHelpers.ParseServerDateTime(data.createdAt);
  }

  static zero(): QuoteConfigSummary {
    const zeroValues: ExcludeMethodsDeep<QuoteConfigSummary> = {
      id: NIL_UUID,
      name: '',
      plants: [],
      isArchived: false,
      plantIsArchived: false,
      createdAt: DateHelpers.ParseServerDateTime(DateHelpers.ZERO_DATE_STRING),
    };
    return new QuoteConfigSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteConfigSummaryWireFormat = {
  id: string;
  name: string;
  plants: QuoteConfigSummaryPlantWireFormat[];
  isArchived: boolean;
  plantIsArchived: boolean;
  createdAt: string;
};

type NewQuoteConfigSummaryProps = PartialDeep<QuoteConfigSummary, { recurseIntoArrays: true }>;
export const NewQuoteConfigSummary: (props: NewQuoteConfigSummaryProps) => QuoteConfigSummary = (
  props,
) => new QuoteConfigSummary(props);

type NewQuoteConfigSummaryFromWireFormatProps = PartialDeep<
  QuoteConfigSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteConfigSummaryFromWireFormat: (
  props: NewQuoteConfigSummaryFromWireFormatProps,
) => QuoteConfigSummary = (props) => new QuoteConfigSummary(props);
